/* eslint-disable eqeqeq */
import React, { useState, useLayoutEffect, useEffect } from "react";

/** Components */
import { Button, TablePagination, Paper, TableContainer, Table, TableHead, TableBody, TableCell, TableRow, TableFooter, Collapse, ButtonGroup, Checkbox, Tooltip } from "@mui/material";
import { FilterBy } from "../../commons/filter.component";
import ButtonWithAPICall from "../../commons/ButtonWithAPICall.component";
import SelectStatusButton, { statusOptions } from "../../commons/SelectStatusButton";
import LoadingProgress from "../../commons/LoadingProgress.component";

/** Icons */
import SearchIcon from "@mui/icons-material/Search";
import RefreshIcon from "@mui/icons-material/Refresh";

/** Api & Function */
import { getCustomers, getLoadingType, getPO, postSync, updatePOStatus } from "./../../../services/api";
import { convertQueryStringToObject } from "../../../services/libService";
import { setHeaderTitle } from "../../../store/layoutSlide";

/** Package */
import moment from "moment";
import { useTranslation } from "react-i18next";

/** Hook */
import { useParamFilter } from "../../commons/customHook";

import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { useDispatch } from "react-redux";

export default function PO() {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const [isSearchOpen, setSearchOpen] = useState(true);
  // custom hook
  const location = useLocation();
  const { fetchData, data, setData, page, perPage, setPage, setPerPage, total, isAllow, loading } = useParamFilter({ page: 1, per_page: 50 }, getPO);
  const filter = convertQueryStringToObject(location.search);

  const [changeIds, setChangeIds] = useState([]); //ids cua nhung index can cap nhat
  const handleCheckBoxClick = (id) => {
    if (changeIds.includes(id)) setChangeIds((prev) => prev.filter((item) => item !== id));
    else setChangeIds((prev) => [...prev, id]);
  };
  const handleUpdateStatus = (selectedStatus) => {
    return updatePOStatus({ ids: changeIds, action: selectedStatus.action });
  };
  const handleUpdateStatusResponse = (res, selectedStatus) => {
    if (res.code === 200) {
      let newStatus;
      switch (selectedStatus.action) {
        case 0:
          newStatus = "DEACTIVATED";
          break;
        case 1:
          newStatus = "ACTIVATED";
          break;
        case 4:
          setChangeIds([]);
          newStatus = "DELETED";
          break;
        default:
          break;
      }
      setData(data.map((item) => (changeIds.includes(item.id) ? { ...item, status: newStatus } : item)));
    }
  };

  const [input, setInput] = useState({
    selectedCustomer: null,
    loadingtype: null,
    status: null,
  });
  const handleSearch = () => {
    setChangeIds([]);
    fetchData((prev) => ({
      ...input,
      type: prev.type,
      selectedCustomer: undefined,
      provider_id: input.selectedCustomer?.id,
      loadingtype: undefined,
      loadingtype_id: input.loadingtype?.id,
      status: input.status?.action,
    }));
  };
  // effect
  useLayoutEffect(() => {
    fetchData(convertQueryStringToObject(location.search));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(setHeaderTitle("THÔNG TIN ĐƠN MUA - NHẬP HÀNG"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div>
      <div align="right" style={{ marginBottom: 10, marginTop: 10, backgroundColor: "#b3deff", height: 40 }}>
        <ButtonGroup style={{ height: 40, marginRight: 10 }}>
          <ButtonWithAPICall title="Lấy dữ liệu từ ERP" api={() => postSync({ object: "po" })} variant="outlined">
            <RefreshIcon />
          </ButtonWithAPICall>
          <Button onClick={() => setSearchOpen((prev) => !prev)} variant="outlined">
            <Tooltip>
              <SearchIcon />
            </Tooltip>
          </Button>
        </ButtonGroup>
      </div>
      <div>
        <Collapse in={isSearchOpen}>
          <FilterBy
            style={{ display: "inline-flex", margin: "5px", minWidth: 240 }}
            getDataFunc={() => getCustomers({ status: 1 })}
            value={input.selectedCustomer || null}
            onChange={(e, newValue) => setInput((prev) => ({ ...prev, selectedCustomer: newValue }))}
            label={t("Nhà cung cấp")}
            setDefaultFunc={(option) => setInput((prev) => ({ ...prev, selectedCustomer: option.find((item) => item.id == filter.provider_id) }))}
            triggerSetDefaultFunc={true}
            setDefaultDependencies={[filter.provider_id]}
          />
          <FilterBy
            style={{ display: "inline-flex", margin: "5px", minWidth: 240 }}
            getDataFunc={() => getLoadingType({ status: 1 })}
            value={input.loadingtype || null}
            onChange={(e, newValue) => setInput((prev) => ({ ...prev, loadingtype: newValue }))}
            label={t("Kiểu vận chuyển")}
            setDefaultFunc={(option) => setInput((prev) => ({ ...prev, loadingtype: option.find((item) => item.id == filter.loadingtype_id) }))}
            triggerSetDefaultFunc={true}
            setDefaultDependencies={[filter.loadingtype_id]}
          />
          <FilterBy
            style={{ display: "inline-flex", minWidth: 200, margin: "5px" }}
            label={t("Trạng thái")}
            getOptionLabel={(option) => t(option.label) || ""}
            isOptionEqualToValue={(option, value) => option?.action === value?.action}
            getDataFunc={() => Promise.resolve({ data: statusOptions, code: 200 })}
            value={input.status}
            onChange={(e, newValue) => setInput((prev) => ({ ...prev, status: newValue }))}
            setDefaultFunc={(option) => setInput((prev) => ({ ...prev, status: option.find((item) => item.action == filter.status) }))}
            triggerSetDefaultFunc={true}
            setDefaultDependencies={[filter.status]}
          />
          <Button variant="outlined" onClick={handleSearch} style={{ margin: "10px 0" }}>
            {t("Tìm kiếm")}
          </Button>
        </Collapse>
        <div style={{ display: "flex" }}>
          {loading ? (
            <LoadingProgress />
          ) : (
            <TableContainer component={Paper} style={{ width: "98%", marginLeft: 10 }} sx={{ maxHeight: 800 }}>
              <Table stickyHeader>
                <TableHead style={{ backgroundColor: "#f0f3f5" }}>
                  <TableRow>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                      STT
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                      {t("ERP ID")}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                      {t("Kiểu vận chuyển")}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                      {t("Số PO")}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                      {t("Nhà cung cấp")}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                      {t("Tuyến đường")}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray", minWidth: 100 }} align="center">
                      {t("Hàng hóa")}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                      {t("Đơn vị")}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                      {t("Ngày hiệu lực")}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                      {t("Ngày hết hạn")}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                      {t("Loại tiền")}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                      {t("Tỷ giá")}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                      {t("Trạng thái")}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>
                      <SelectStatusButton disabled={!changeIds.length} api={handleUpdateStatus} response={handleUpdateStatusResponse} />
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.length ? (
                    data.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                          {item.id}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                          {item.erp_id}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                          {item.loading_name}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                          {item.trx_number}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="left">
                          {item.provider_name}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                          {item.route}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                          {item.product_name}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                          {item.product_unit}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                          {item.effect_date && moment(item.effect_date).format("DD/MM/YYYY")}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                          {item.exp_date && moment(item.exp_date).format("DD/MM/YYYY")}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                          {item.currency}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                          {item.exrate?.toLocaleString()}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                          {t(item.status)}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }}>
                          <Checkbox disabled={item.status === "DELETED"} checked={changeIds.includes(item.id)} onClick={handleCheckBoxClick.bind(this, item.id)} />
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell align="center" colSpan={20}>
                        {t(isAllow ? "Không có dữ liệu" : "No permission")}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination rowsPerPageOptions={[50, 100, 150]} count={total || 0} rowsPerPage={perPage} page={page} onPageChange={setPage} onRowsPerPageChange={setPerPage} />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          )}
        </div>
      </div>
    </div>
  );
}
